exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "input[type=file][data-v-0d4e0196]{width:100%;height:100%;position:absolute;top:0;left:0;opacity:0;cursor:pointer}.fa-paperclip[data-v-0d4e0196]{color:#119bd2}.label-import[data-v-0d4e0196]{font-style:italic}.button-clear-file[data-v-0d4e0196]{background-color:transparent;border:none}.label-text[data-v-0d4e0196]{font-weight:500}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-0d4e0196","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./src/components/modalComponents/modalImporterTopaze/modalImporterTopaze.scss
// module id = lpMa
// module chunks = 2